import { Skeleton } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const TaskStatusFieldSkeleton = () => {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Skeleton height={12} variant="circular" width={12} />
          <Skeleton height={20} variant="text" width={90} />
        </Box>
        <Skeleton height={20} variant="text" width={130} />
      </Box>
      <Skeleton height={8} sx={{ borderRadius: 4 }} variant="rounded" width="100%" />
    </Box>
  );
};
